// Country data for dedicated landing pages
// Each entry: ~900-word SEO-optimized content block + structured data

export const COUNTRIES = {
  usa: {
    slug: "usa",
    name: "USA",
    fullName: "United States of America",
    flag: "🇺🇸",
    tagline: "The land of Ivy, innovation & endless possibility.",
    heroImg: "https://images.unsplash.com/photo-1485738422979-f5c462d49f74?auto=format&fit=crop&w=1600&q=70",
    metaTitle: "Study in USA from India 2026 — MS, MBA & Bachelor's Consultants | Shah Overseas",
    metaDesc: "Expert study abroad consultants for USA from India. Get admission into top US universities — Stanford, MIT, Harvard, CMU. F-1 visa guidance, GRE/GMAT/TOEFL coaching. 350+ universities. Apply for Fall 2026.",
    keywords: "study in USA from India, MS in USA consultants, MBA in USA from India, US student visa consultants, F-1 visa guidance, study abroad USA Nagpur, top universities in USA for Indian students, Fall 2026 USA intake",
    intro: "The **United States** remains the #1 study-abroad destination for Indian students — for good reason. Home to 8 of the world's top 10 universities, an unmatched research ecosystem, and the strongest job market for international graduates via the 3-year STEM OPT extension. Shah Overseas Education has helped 12,000+ Indian students secure admission into US universities since 2014, from Stanford and MIT to rising state schools.",
    stats: [
      { v: "1,000+", l: "Top Universities" },
      { v: "3 Years", l: "STEM OPT" },
      { v: "$1.5M+", l: "Scholarships Won" },
      { v: "95%", l: "Visa Success Rate" },
    ],
    topUniversities: [
      { name: "Stanford University", domain: "stanford.edu", city: "California" },
      { name: "Massachusetts Institute of Technology", domain: "mit.edu", city: "Massachusetts" },
      { name: "Harvard University", domain: "harvard.edu", city: "Massachusetts" },
      { name: "Carnegie Mellon University", domain: "cmu.edu", city: "Pennsylvania" },
      { name: "UC Berkeley", domain: "berkeley.edu", city: "California" },
      { name: "Columbia University", domain: "columbia.edu", city: "New York" },
      { name: "University of Michigan", domain: "umich.edu", city: "Michigan" },
      { name: "Cornell University", domain: "cornell.edu", city: "New York" },
    ],
    popularCourses: ["MS in Computer Science", "MBA / Management", "MS in Data Science & AI", "MS in Electrical Engineering", "MS in Business Analytics", "Bachelor's in CS / Engineering"],
    costBreakdown: [
      { item: "Tuition (per year)", value: "₹25 – 55 lakh" },
      { item: "Living Expenses (per year)", value: "₹10 – 18 lakh" },
      { item: "Health Insurance", value: "₹1 – 2 lakh" },
      { item: "Total for MS (2 years)", value: "₹70 lakh – 1.4 crore" },
    ],
    testScores: [
      { test: "TOEFL iBT", req: "90+ (Top 50: 100+)" },
      { test: "IELTS", req: "7.0+ (Top 50: 7.5+)" },
      { test: "GRE", req: "315+ (Top 20: 325+)" },
      { test: "GMAT", req: "680+ (Top MBA: 720+)" },
    ],
    visaInfo: {
      type: "F-1 Student Visa",
      steps: "I-20 issuance → SEVIS fee → DS-160 → Embassy interview. Shah Overseas conducts 4+ mock interviews. 95% success rate.",
    },
    scholarships: "Merit-based fellowships, need-based grants, research/teaching assistantships (covers 50-100% tuition + stipend). Our students have secured $60K+ Graduate Fellowships at CMU, UC Berkeley, and Columbia.",
    process: [
      "Profile evaluation & career counselling",
      "University shortlisting (Reach / Match / Safety)",
      "GRE / GMAT / TOEFL / IELTS coaching",
      "SOP, LOR & resume crafting",
      "Application submission (Common App & direct)",
      "Financial documentation & I-20 processing",
      "F-1 visa interview prep & mock sessions",
      "Pre-departure & US arrival orientation",
    ],
    faqs: [
      { q: "How much does it cost to study MS in USA from India?", a: "Total cost ranges from ₹70 lakh to ₹1.4 crore for a 2-year MS including tuition, living, and insurance. Scholarships and assistantships can reduce this by 30-100%." },
      { q: "Is GRE mandatory for MS in USA in 2026?", a: "Most top US universities (especially engineering & sciences) still require GRE. However, some programs have gone GRE-optional post-pandemic — Shah Overseas tracks this list yearly and advises accordingly." },
      { q: "What are the F-1 visa success rates for Indian students?", a: "The national average is around 78%. Shah Overseas students have a 95% F-1 visa approval rate because we prep you through 4+ mock interviews, financial document review, and red-flag rehearsal." },
      { q: "Can I work in the USA after my degree?", a: "Yes. OPT gives 12 months of work authorization for any degree; STEM OPT adds 24 more months (3 years total) for STEM graduates. Most Indian MS students use this window to convert to H-1B." },
      { q: "When should I start applying for Fall 2026 intake?", a: "Ideal timeline: test prep Jan-May 2025, SOP/LOR June-Aug, applications Sep-Dec 2025, visa interviews Apr-Jun 2026, departure Aug 2026. We recommend reaching out 12-15 months before intake." },
    ],
  },

  uk: {
    slug: "uk",
    name: "UK",
    fullName: "United Kingdom",
    flag: "🇬🇧",
    tagline: "Heritage universities. 1-year Master's. Post-study work visa.",
    heroImg: "https://images.unsplash.com/photo-1486299267070-83823f5448dd?auto=format&fit=crop&w=1600&q=70",
    metaTitle: "Study in UK from India 2026 — MSc, MBA Consultants | Shah Overseas Education",
    metaDesc: "Top UK study abroad consultants in India. Admission into Oxford, Cambridge, Imperial, UCL & Russell Group universities. 1-year MSc, Tier-4/Student visa, 2-year Graduate Route post-study work visa. IELTS coaching.",
    keywords: "study in UK from India, MSc in UK consultants, MBA in UK, UK student visa consultants, Tier 4 visa, Graduate Route visa, Russell Group universities, study in London from India, UK intake September 2026",
    intro: "The **United Kingdom** offers one of the most time-efficient study routes for Indian students — a 1-year Master's degree from a Russell Group university, followed by a 2-year Graduate Route post-study work visa. With institutions dating back 900+ years and a globally recognised qualification, the UK remains a premier choice for MSc, MBA, and PhD aspirants. Shah Overseas has secured admissions at Oxford, Cambridge, Imperial, and LSE with £28K+ average scholarships.",
    stats: [
      { v: "150+", l: "Universities" },
      { v: "1 Year", l: "MSc Duration" },
      { v: "2 Years", l: "Graduate Route" },
      { v: "£28K+", l: "Avg Scholarship" },
    ],
    topUniversities: [
      { name: "University of Oxford", domain: "ox.ac.uk", city: "Oxford" },
      { name: "University of Cambridge", domain: "cam.ac.uk", city: "Cambridge" },
      { name: "Imperial College London", domain: "imperial.ac.uk", city: "London" },
      { name: "University College London", domain: "ucl.ac.uk", city: "London" },
      { name: "London School of Economics", domain: "lse.ac.uk", city: "London" },
      { name: "University of Edinburgh", domain: "ed.ac.uk", city: "Edinburgh" },
      { name: "King's College London", domain: "kcl.ac.uk", city: "London" },
      { name: "University of Manchester", domain: "manchester.ac.uk", city: "Manchester" },
    ],
    popularCourses: ["MSc Data Science / AI", "MBA (1-year)", "MSc Finance & Management", "MSc Computer Science", "MSc Engineering", "MSc Public Health / Law"],
    costBreakdown: [
      { item: "Tuition (per year)", value: "₹20 – 45 lakh" },
      { item: "Living (per year, outside London)", value: "₹9 – 13 lakh" },
      { item: "Living (London)", value: "₹13 – 18 lakh" },
      { item: "Total for 1-year MSc", value: "₹35 – 65 lakh" },
    ],
    testScores: [
      { test: "IELTS Academic", req: "6.5 – 7.5 (Oxbridge: 7.5+)" },
      { test: "TOEFL iBT", req: "92+ (Top 10: 110+)" },
      { test: "GMAT (MBA)", req: "600+ (LBS: 700+)" },
      { test: "PTE Academic", req: "62+" },
    ],
    visaInfo: {
      type: "Student Route (Tier 4) Visa",
      steps: "CAS from university → CAS acceptance → IHS payment → Visa application → Biometrics. Usually processed in 15 working days.",
    },
    scholarships: "Chevening Scholarship (full-ride, UK gov), Commonwealth Scholarships, GREAT Scholarships (£10K), plus university-specific awards like Clarendon (Oxford), Gates-Cambridge, and Imperial President's Scholarship.",
    process: [
      "Career & profile counselling",
      "Shortlisting — Russell Group + specialist unis",
      "IELTS / PTE / GMAT coaching",
      "SOP, personal statement & LOR drafting",
      "UCAS (undergrad) or direct (PG) application",
      "CAS processing & IHS payment",
      "Student visa interview & documentation",
      "Pre-departure + UK arrival support",
    ],
    faqs: [
      { q: "How long is a Master's degree in the UK?", a: "Most UK Master's programs are 1 year (12 months), making them 50% faster than 2-year programs in USA/Australia — you save a full year of tuition and living cost, and start earning a year earlier." },
      { q: "What is the Graduate Route visa?", a: "After graduating from a UK university, you get a 2-year post-study work visa (3 years for PhDs) with no job sponsor required. You can work for any employer, switch jobs, or start your own business." },
      { q: "Is IELTS mandatory for UK universities?", a: "Yes, or an accepted alternative (TOEFL, PTE). Minimum 6.5 overall with 6.0 in each band for most universities; Oxford, Cambridge, Imperial require 7.0 – 7.5." },
      { q: "What's the total cost for a 1-year MSc in UK?", a: "₹35 – 65 lakh all-in (tuition + living + visa + flights). London programs are higher; cities like Manchester, Birmingham, Glasgow offer lower living costs." },
      { q: "Can my spouse accompany me on a UK student visa?", a: "From Jan 2024, only PhD and research programs allow dependents. For taught Master's and Bachelor's, dependents cannot accompany — spouses can apply separately later." },
    ],
  },

  canada: {
    slug: "canada",
    name: "Canada",
    fullName: "Canada",
    flag: "🇨🇦",
    tagline: "Friendly visas. Permanent residency pathway. Affordable world-class education.",
    heroImg: "https://images.unsplash.com/photo-1517935706615-2717063c2225?auto=format&fit=crop&w=1600&q=70",
    metaTitle: "Study in Canada from India 2026 — Top Consultants | Shah Overseas Education",
    metaDesc: "Canada study abroad consultants for Indian students. Admission to University of Toronto, UBC, McGill, Waterloo. Study permit guidance, 3-year PGWP, PR pathway via Express Entry. Fall 2026 intake.",
    keywords: "study in Canada from India, Canada student visa consultants, Canada study permit, PGWP Canada, PR through study in Canada, University of Toronto admission, SDS visa Canada, Fall 2026 Canada intake",
    intro: "**Canada** has become the fastest-growing study destination for Indian students — thanks to affordable tuition (40% lower than USA/UK), a straightforward study permit process under SDS, and a clear 3-year Post-Graduation Work Permit (PGWP) that leads to **Permanent Residency via Express Entry**. Shah Overseas has placed 8,000+ Indian students at the University of Toronto, UBC, McGill, Waterloo, and strong Canadian colleges.",
    stats: [
      { v: "100+", l: "Universities" },
      { v: "3 Years", l: "PGWP" },
      { v: "PR Pathway", l: "via Express Entry" },
      { v: "Jan / May / Sep", l: "3 Intakes/Year" },
    ],
    topUniversities: [
      { name: "University of Toronto", domain: "utoronto.ca", city: "Toronto" },
      { name: "University of British Columbia", domain: "ubc.ca", city: "Vancouver" },
      { name: "McGill University", domain: "mcgill.ca", city: "Montreal" },
      { name: "University of Waterloo", domain: "uwaterloo.ca", city: "Waterloo" },
      { name: "McMaster University", domain: "mcmaster.ca", city: "Hamilton" },
      { name: "Western University", domain: "uwo.ca", city: "London, ON" },
      { name: "University of Alberta", domain: "ualberta.ca", city: "Edmonton" },
      { name: "Queen's University", domain: "queensu.ca", city: "Kingston" },
    ],
    popularCourses: ["MS / PG Dip in Data Science & AI", "MBA (Rotman, Ivey, Schulich)", "MEng / MASc in Engineering", "PG Dip in Business Analytics", "Bachelor's (Co-op programs)", "Healthcare & Nursing"],
    costBreakdown: [
      { item: "Tuition (per year)", value: "₹12 – 30 lakh" },
      { item: "Living Expenses", value: "₹8 – 12 lakh" },
      { item: "GIC (proof of funds)", value: "₹6.35 lakh (refundable)" },
      { item: "Total for 2-year program", value: "₹45 – 75 lakh" },
    ],
    testScores: [
      { test: "IELTS Academic", req: "6.5 (UG), 7.0 (PG)" },
      { test: "TOEFL iBT", req: "86+ (PG: 90+)" },
      { test: "PTE Academic", req: "60+" },
      { test: "GRE", req: "Optional (recommended for top unis)" },
    ],
    visaInfo: {
      type: "Study Permit (SDS route)",
      steps: "LOA from DLI → GIC deposit ₹6.35L → IELTS 6.0+ → Upfront tuition → SDS application (visa in 20 days).",
    },
    scholarships: "Ontario Graduate Scholarship (CAD 15K), Vanier Canada Graduate Scholarship (CAD 50K/yr for PhDs), UBC International Leader of Tomorrow Award, plus university-specific merit aid covering 20-50% tuition.",
    process: [
      "Career & profile evaluation",
      "DLI shortlisting (universities + colleges)",
      "IELTS coaching + diagnostic",
      "SOP & application package",
      "LOA & GIC processing",
      "Study permit via SDS route (fast-track)",
      "Biometrics & passport submission",
      "Pre-departure & Canadian arrival",
    ],
    faqs: [
      { q: "How does PR via study in Canada work?", a: "After graduating, you get a 3-year PGWP and 1 year of Canadian work experience qualifies you for Express Entry (CEC stream). Most Shah Overseas alumni get PR within 4-5 years of landing." },
      { q: "What is the SDS visa route?", a: "Student Direct Stream — a fast-track study permit pathway for Indian students: requires IELTS 6.0+, GIC of CAD 10,000, upfront tuition. Processing within 20 days, 90% approval rate." },
      { q: "Is Canada cheaper than USA for MS?", a: "Yes — total cost ₹45-75 lakh vs ₹70 lakh-1.4 crore in USA. Tuition is 40-50% lower, and Canadian PR benefits offset the initial investment within 3-4 years." },
      { q: "Can I work while studying in Canada?", a: "Yes — 20 hours/week during semester, 40 hours/week during breaks, no additional work permit needed. Minimum wage ~CAD 16-17/hour covers groceries and part of rent." },
      { q: "Which intake is best for Canada — Fall or Winter?", a: "Fall (September) has the widest program availability and strongest job market entry. Winter (January) is great if you miss Fall deadlines. Summer (May) is limited but useful for college diplomas." },
    ],
  },

  australia: {
    slug: "australia",
    name: "Australia",
    fullName: "Australia",
    flag: "🇦🇺",
    tagline: "World-class unis. 4-year post-study work visa. Beach + ballpark.",
    heroImg: "https://images.unsplash.com/photo-1523482580672-f109ba8cb9be?auto=format&fit=crop&w=1600&q=70",
    metaTitle: "Study in Australia from India 2026 — Subclass 500 Visa Consultants | Shah Overseas",
    metaDesc: "Australia study abroad consultants in India. Admission to Melbourne, Sydney, ANU, UNSW, Monash. Subclass 500 student visa, 2-4 year post-study work visa (485), PR pathway. IELTS/PTE coaching.",
    keywords: "study in Australia from India, Australia student visa, Subclass 500 visa, Subclass 485 post study work visa, University of Melbourne admission, Group of Eight Australia, February 2026 intake",
    intro: "**Australia** offers the Group of Eight (Go8) — a coalition of world-class universities consistently ranked in the global top 50. With one of the most generous post-study work visas (up to 4 years under Subclass 485), clear PR pathways, and a February/July dual intake system, Australia is ideal for Indian students seeking global credentials and long-term settlement. Shah Overseas has placed 6,500+ students across Go8 and strong regional universities.",
    stats: [
      { v: "43", l: "Universities" },
      { v: "2–4 Years", l: "Post-Study Work" },
      { v: "Feb / Jul", l: "Dual Intake" },
      { v: "A$38K+", l: "Avg Scholarship" },
    ],
    topUniversities: [
      { name: "University of Melbourne", domain: "unimelb.edu.au", city: "Melbourne" },
      { name: "Australian National University", domain: "anu.edu.au", city: "Canberra" },
      { name: "University of Sydney", domain: "sydney.edu.au", city: "Sydney" },
      { name: "UNSW Sydney", domain: "unsw.edu.au", city: "Sydney" },
      { name: "Monash University", domain: "monash.edu", city: "Melbourne" },
      { name: "University of Queensland", domain: "uq.edu.au", city: "Brisbane" },
      { name: "University of Western Australia", domain: "uwa.edu.au", city: "Perth" },
      { name: "University of Adelaide", domain: "adelaide.edu.au", city: "Adelaide" },
    ],
    popularCourses: ["Master's in IT / Data Science", "MBA (Go8 business schools)", "Master's in Engineering", "Healthcare & Nursing", "Bachelor's in Business / Accounting", "Master of Professional Accounting"],
    costBreakdown: [
      { item: "Tuition (per year)", value: "₹20 – 40 lakh" },
      { item: "Living Expenses", value: "₹10 – 14 lakh" },
      { item: "OSHC Health Insurance", value: "₹40K – 80K/year" },
      { item: "Total for 2-year Master's", value: "₹55 – 90 lakh" },
    ],
    testScores: [
      { test: "IELTS Academic", req: "6.5 overall, 6.0 each band" },
      { test: "PTE Academic", req: "58 – 65+" },
      { test: "TOEFL iBT", req: "79 – 94+" },
      { test: "GRE / GMAT", req: "Optional for most" },
    ],
    visaInfo: {
      type: "Subclass 500 Student Visa",
      steps: "CoE from university → Genuine Student (GS) statement → OSHC → Financial evidence → Visa application. Processing ~4-6 weeks.",
    },
    scholarships: "Australia Awards Scholarship (full-ride), Destination Australia (AUD 15K), plus university awards like Melbourne International Scholarship, UNSW Scientia, ANU Chancellor's International Scholarship.",
    process: [
      "Career counselling & profile eval",
      "Go8 + regional university shortlist",
      "PTE / IELTS coaching",
      "SOP, GS statement & reference prep",
      "Application submission",
      "CoE & OSHC processing",
      "Subclass 500 visa application",
      "Pre-departure & arrival support",
    ],
    faqs: [
      { q: "How long can I work in Australia after graduating?", a: "Subclass 485 post-study work visa: 2 years for Bachelor's/Master's by coursework, 3 years for Master's by research, 4 years for PhDs. Regional study can add +1-2 years bonus." },
      { q: "Is IELTS or PTE better for Australian universities?", a: "Both are accepted equally. PTE is often preferred as it's computer-based with 48-hour results. Shah Overseas coaches both — we recommend PTE for students strong in typing and comfortable with AI scoring." },
      { q: "What is the Genuine Student (GS) requirement?", a: "From March 2024, the Genuine Student criteria replaced the earlier GTE. You submit a written statement explaining why you chose this course, your ties to India, and post-study plans. Shah Overseas drafts this for you." },
      { q: "Can my spouse work full-time in Australia?", a: "Yes — dependents of Master's and PhD students can work unlimited hours. Dependents of Bachelor's students can work 48 hours per fortnight." },
      { q: "Which Australian cities are cheaper to live in?", a: "Adelaide, Perth, Brisbane, and regional cities like Canberra, Hobart cost ~30% less than Sydney/Melbourne. Regional study also earns +1 year bonus post-study work visa." },
    ],
  },

  ireland: {
    slug: "ireland",
    name: "Ireland",
    fullName: "Republic of Ireland",
    flag: "🇮🇪",
    tagline: "The tech capital of Europe. English-speaking. 2-year stay-back.",
    heroImg: "https://images.unsplash.com/photo-1564959130747-897fb406b9af?auto=format&fit=crop&w=1600&q=70",
    metaTitle: "Study in Ireland from India 2026 — Trinity, UCD Consultants | Shah Overseas",
    metaDesc: "Ireland study abroad consultants. Admission to Trinity College Dublin, UCD, NUI Galway, University College Cork. Stamp 2 student visa, 2-year stay-back, tech job market at Google, Meta, LinkedIn EU HQs.",
    keywords: "study in Ireland from India, Ireland student visa Stamp 2, Trinity College Dublin admission, UCD masters, study in Dublin, 2 year stay back Ireland, Ireland intake September 2026",
    intro: "**Ireland** has emerged as Europe's tech capital — with European HQs of Google, Meta, LinkedIn, Microsoft, Apple, and Pfizer all in Dublin. An English-speaking country with world-class universities, generous 2-year stay-back for Master's graduates, and a strong employment pathway for Indian STEM students. Shah Overseas has placed 2,500+ students at Trinity, UCD, and NUI Galway with €32K+ average scholarships.",
    stats: [
      { v: "8", l: "Top Universities" },
      { v: "2 Years", l: "Stay-Back Option" },
      { v: "€32K+", l: "Avg Scholarship" },
      { v: "Sep / Jan", l: "Dual Intake" },
    ],
    topUniversities: [
      { name: "Trinity College Dublin", domain: "tcd.ie", city: "Dublin" },
      { name: "University College Dublin", domain: "ucd.ie", city: "Dublin" },
      { name: "University College Cork", domain: "ucc.ie", city: "Cork" },
      { name: "NUI Galway", domain: "universityofgalway.ie", city: "Galway" },
      { name: "Dublin City University", domain: "dcu.ie", city: "Dublin" },
      { name: "University of Limerick", domain: "ul.ie", city: "Limerick" },
      { name: "Maynooth University", domain: "maynoothuniversity.ie", city: "Maynooth" },
      { name: "Technological University Dublin", domain: "tudublin.ie", city: "Dublin" },
    ],
    popularCourses: ["MSc Computer Science / AI", "MSc Data Analytics", "MBA / Finance", "MSc FinTech", "MSc Pharmaceutical Sciences", "MSc Biotechnology"],
    costBreakdown: [
      { item: "Tuition (per year)", value: "₹13 – 28 lakh" },
      { item: "Living in Dublin", value: "₹10 – 13 lakh" },
      { item: "Living outside Dublin", value: "₹7 – 9 lakh" },
      { item: "Total for 1-year MSc", value: "₹25 – 42 lakh" },
    ],
    testScores: [
      { test: "IELTS Academic", req: "6.5 overall, 6.0 per band" },
      { test: "TOEFL iBT", req: "88+" },
      { test: "PTE Academic", req: "61+" },
      { test: "GRE / GMAT", req: "Not mandatory" },
    ],
    visaInfo: {
      type: "Stamp 2 Study Visa",
      steps: "LOA from Irish uni → Proof of funds €10K → Health insurance → Visa application. Processing 4-8 weeks.",
    },
    scholarships: "Government of Ireland International Education Scholarship (full-ride, 60 awards/year), Trinity Global Scholarship, UCD Global Excellence Scholarship (€10-15K), plus fully-funded SFI research opportunities.",
    process: [
      "Career counselling & shortlisting",
      "IELTS / PTE coaching",
      "SOP & LOR drafting",
      "Application submission (CAO or direct)",
      "LOA + proof-of-funds documentation",
      "Stamp 2 visa application",
      "Accommodation assistance",
      "Pre-departure + Dublin arrival support",
    ],
    faqs: [
      { q: "Why is Ireland called Europe's tech capital?", a: "14 of the top 15 global tech companies have European HQs in Ireland (Dublin), hiring 100K+ international grads. Corporate tax rate of 12.5% drew Google, Meta, Apple, LinkedIn, Microsoft — all actively recruiting Shah Overseas alumni." },
      { q: "Is a 1-year MSc in Ireland recognized globally?", a: "Yes. Irish degrees are part of the European Qualifications Framework (EQF), recognized across EU and globally equivalent to UK/Australian Master's degrees." },
      { q: "How long can I stay after graduation?", a: "2 years on Stamp 1G (Third Level Graduate Scheme) for Master's graduates. 90% of our Irish alumni secure full-time roles within 6 months, converting to Critical Skills Employment Permit." },
      { q: "What is the Critical Skills Employment Permit?", a: "A fast-track work permit for roles paying €32K+ (or €64K+ for non-critical). After 2 years on CSEP, you can apply for Stamp 4 (similar to PR), leading to citizenship in 5 years." },
      { q: "Is Ireland cheaper than UK for studying?", a: "Living costs outside Dublin are 25-30% lower than London. Total 1-year MSc cost: ₹25-42 lakh vs ₹35-65 lakh in UK. Dublin is comparable to London, but Cork, Galway, and Limerick are very affordable." },
    ],
  },

  "new-zealand": {
    slug: "new-zealand",
    name: "New Zealand",
    fullName: "New Zealand",
    flag: "🇳🇿",
    tagline: "Scenic. Safe. 3-year post-study work visa.",
    heroImg: "https://images.unsplash.com/photo-1469521669194-babb45599def?auto=format&fit=crop&w=1600&q=70",
    metaTitle: "Study in New Zealand from India 2026 — Student Visa Consultants | Shah Overseas",
    metaDesc: "New Zealand study abroad consultants for Indian students. Admission at University of Auckland, Otago, Victoria, Canterbury. 3-year post-study work visa, residency pathway. Fee Waiver Scholarships.",
    keywords: "study in New Zealand from India, NZ student visa, University of Auckland admission, 3 year post study work visa NZ, PR through study New Zealand, Feb 2026 NZ intake",
    intro: "**New Zealand** offers globally top-ranked universities, breathtaking landscapes, and one of the world's most welcoming post-study work pathways — up to **3 years of open work rights** after a Master's degree, plus a clear residency pathway. Ideal for Indian students who want a balanced, safe, and career-friendly study-abroad experience. Shah Overseas has placed 1,500+ students across all 8 NZ universities.",
    stats: [
      { v: "8", l: "Universities" },
      { v: "3 Years", l: "Post-Study Work" },
      { v: "PR Pathway", l: "via SMC" },
      { v: "Feb / Jul", l: "Dual Intake" },
    ],
    topUniversities: [
      { name: "University of Auckland", domain: "auckland.ac.nz", city: "Auckland" },
      { name: "University of Otago", domain: "otago.ac.nz", city: "Dunedin" },
      { name: "Victoria University of Wellington", domain: "wgtn.ac.nz", city: "Wellington" },
      { name: "University of Canterbury", domain: "canterbury.ac.nz", city: "Christchurch" },
      { name: "Massey University", domain: "massey.ac.nz", city: "Palmerston North" },
      { name: "Lincoln University", domain: "lincoln.ac.nz", city: "Lincoln" },
      { name: "University of Waikato", domain: "waikato.ac.nz", city: "Hamilton" },
      { name: "Auckland University of Technology", domain: "aut.ac.nz", city: "Auckland" },
    ],
    popularCourses: ["Master of IT / CS", "MBA (Auckland, Otago)", "Master of Engineering", "Master of Business Analytics", "Bachelor's in Business / Science", "Master of Applied Finance"],
    costBreakdown: [
      { item: "Tuition (per year)", value: "₹15 – 30 lakh" },
      { item: "Living Expenses", value: "₹10 – 13 lakh" },
      { item: "Health Insurance", value: "₹30K – 50K/year" },
      { item: "Total for 2-year Master's", value: "₹45 – 75 lakh" },
    ],
    testScores: [
      { test: "IELTS Academic", req: "6.0 – 6.5" },
      { test: "PTE Academic", req: "50 – 58" },
      { test: "TOEFL iBT", req: "80 – 90" },
    ],
    visaInfo: {
      type: "Fee-Paying Student Visa",
      steps: "Offer letter → Proof of funds NZD 20K/year → Health & character requirements → Online visa application. Processing ~4-8 weeks.",
    },
    scholarships: "New Zealand International Doctoral Research Scholarship (full-ride for PhDs), University of Auckland International Student Excellence Scholarship, plus Fee Waiver Scholarships covering 25-50% tuition.",
    process: [
      "Career counselling & profile review",
      "University shortlist (8 options)",
      "IELTS / PTE coaching",
      "SOP & application drafting",
      "Offer letter & tuition payment",
      "Student visa + biometrics",
      "Accommodation + flight support",
      "NZ arrival orientation",
    ],
    faqs: [
      { q: "What is the Skilled Migrant Category (SMC) PR pathway?", a: "After graduating and working 1-2 years on a post-study visa, you can apply for PR via SMC — a points-based system rewarding age, qualifications, NZ work experience, and skilled occupation. Shah Overseas helps you plan this from day one." },
      { q: "Is New Zealand safe for Indian students?", a: "Yes — consistently ranked in top 3 safest countries globally (Global Peace Index). Friendly multicultural cities, excellent public healthcare, strict gun laws, and low crime rates make it ideal for students and families." },
      { q: "Can I work during studies in NZ?", a: "Yes — 20 hours/week during semester, unlimited during breaks. Master's and PhD students can work full-time year-round. Minimum wage NZD 23.15/hour (2026) covers rent and groceries comfortably." },
      { q: "How does the 3-year post-study visa work?", a: "Master's graduates get 3 years of open work rights (any employer, any role) — the most generous in the world. Bachelor's graduates get 3 years if studied at levels 7-8, or 2 years for shorter programs." },
      { q: "Is IELTS mandatory for NZ universities?", a: "Yes, unless you've studied in English-medium for 3+ years (NZ universities may waive IELTS in that case). Most programs require 6.0 – 6.5 IELTS — we coach you to these scores in 4-6 weeks." },
    ],
  },

  europe: {
    slug: "europe",
    name: "Europe",
    fullName: "Europe (Germany, France, Netherlands & more)",
    flag: "🇪🇺",
    tagline: "Low tuition. English-taught programs. 30+ countries, one Schengen.",
    heroImg: "https://images.unsplash.com/photo-1502602898657-3e91760cbb34?auto=format&fit=crop&w=1600&q=70",
    metaTitle: "Study in Europe from India 2026 — Germany, France, Netherlands Consultants | Shah Overseas",
    metaDesc: "Europe study abroad consultants for Indian students. Admission in Germany (TU Munich, RWTH), France (HEC, INSEAD), Netherlands (TU Delft), Sweden, Italy, Spain. Low/free tuition, Schengen visa, 18-month job search.",
    keywords: "study in Germany from India, study in France from India, study in Netherlands, Europe student visa, TU Munich admission, HEC Paris MBA, low tuition Europe Indian students, Fall 2026 Europe intake",
    intro: "**Europe** offers some of the world's most affordable high-quality education — **Germany has no/low tuition for international students**, France hosts world-class B-schools (HEC, INSEAD), and Netherlands is famous for English-taught Master's at TU Delft and Erasmus. A Schengen student visa gives you access to 27 countries. Shah Overseas counsels students for Germany, France, Netherlands, Sweden, Spain, and Italy.",
    stats: [
      { v: "27", l: "Schengen Countries" },
      { v: "€0 – 3K", l: "Tuition in Germany" },
      { v: "18 Months", l: "Job Search Visa (DE)" },
      { v: "Fall / Spring", l: "Dual Intake" },
    ],
    topUniversities: [
      { name: "Technical University of Munich", domain: "tum.de", city: "Munich, Germany" },
      { name: "RWTH Aachen", domain: "rwth-aachen.de", city: "Aachen, Germany" },
      { name: "HEC Paris", domain: "hec.edu", city: "Paris, France" },
      { name: "INSEAD", domain: "insead.edu", city: "Fontainebleau, France" },
      { name: "TU Delft", domain: "tudelft.nl", city: "Delft, Netherlands" },
      { name: "University of Amsterdam", domain: "uva.nl", city: "Amsterdam" },
      { name: "KTH Royal Institute", domain: "kth.se", city: "Stockholm, Sweden" },
      { name: "Politecnico di Milano", domain: "polimi.it", city: "Milan, Italy" },
    ],
    popularCourses: ["MS in Engineering (Germany)", "MBA (France — HEC, INSEAD, ESSEC)", "MSc Computer Science (Netherlands)", "MSc Data Science (Sweden, Denmark)", "MSc Design / Architecture (Italy)", "MSc Finance / Economics (Spain, France)"],
    costBreakdown: [
      { item: "Tuition Germany (public)", value: "€0 – 3,000/year" },
      { item: "Tuition France / Netherlands", value: "€9K – 18K/year" },
      { item: "Tuition Sweden / Denmark", value: "€12K – 18K/year" },
      { item: "Living (per month)", value: "€800 – 1,200" },
      { item: "Total for 2-year MS (Germany)", value: "₹18 – 30 lakh" },
    ],
    testScores: [
      { test: "IELTS Academic", req: "6.5 overall" },
      { test: "TOEFL iBT", req: "88+" },
      { test: "GRE (Germany STEM)", req: "315+ recommended" },
      { test: "GMAT (MBA)", req: "650+ (INSEAD/HEC: 700+)" },
      { test: "German (for German-taught)", req: "TestDaF / DSH" },
    ],
    visaInfo: {
      type: "National D / Schengen Student Visa",
      steps: "Admission letter → Blocked account (Germany: €11,208) → Health insurance → Visa application at embassy. Processing 4-12 weeks.",
    },
    scholarships: "DAAD Scholarship (full-ride, Germany), Erasmus Mundus Joint Master's (fully-funded, EU-wide), Eiffel Excellence (France), Holland Scholarship (Netherlands €5K), Swedish Institute Scholarships.",
    process: [
      "Career counselling & country match",
      "University shortlist (public + private)",
      "IELTS / GRE / GMAT coaching",
      "SOP, CV & motivation letter",
      "Uni-assist / direct application",
      "Blocked account & APS (Germany)",
      "Visa application + embassy interview",
      "Pre-departure + Europe arrival",
    ],
    faqs: [
      { q: "Is Germany really free for international students?", a: "Yes — public universities in 15 of 16 German states charge €0 tuition (only Baden-Württemberg charges €1,500/semester). You only pay a semester fee (~€150-350) that includes public transport. Private universities charge €10-20K/year." },
      { q: "Do I need to know German to study in Germany?", a: "Not necessarily — Germany offers 2,000+ English-taught Master's programs. German proficiency (TestDaF) is only required for German-taught courses. However, learning A2-B1 German helps with part-time jobs and integration." },
      { q: "What is the 18-month job search visa in Germany?", a: "After graduating, you get 18 months to find a job relevant to your degree. Once employed, you switch to an EU Blue Card — leading to PR in 21-33 months (faster than any other EU country)." },
      { q: "How affordable is Europe compared to USA/UK?", a: "Very — a 2-year Master's in Germany costs ₹18-30 lakh total (tuition + living) vs ₹70 lakh-1.4 crore in USA or ₹35-65 lakh for 1-year UK MSc. France, Netherlands are mid-range; Nordic countries like Sweden offer excellent value." },
      { q: "Can I work while studying in Europe?", a: "Yes — Germany allows 120 full days or 240 half days/year; Netherlands allows 16 hours/week; France allows 964 hours/year. Minimum wages in Europe (€10-12/hour) cover groceries and utilities for most students." },
    ],
  },

};

export const COUNTRY_LIST = Object.values(COUNTRIES);
